export const SHIFT_EXPIRED_TAB_GROUPING_COLUMN_HEADER_MAP: Record<
  string,
  string | undefined
> = {
  info: "title",
  timeRange: "date",
  partTimeType: "partTimeType",
  appliedRequests: "numberOfApplicants",
  hireStatus: "fulfillmentCount",
};
